export const profileStyles = {
  mainContainer: {
    spacing: '14',
    color: 'brand.text',
    maxWidth: '1050px',
    margin: { base: '0px', sm: '25px auto', md: '50px auto' },
  },
};
